import store from '@/services/store';

import AboutView from './views/AboutView.vue';
import ErrorView from './views/ErrorView.vue';

export default [
  {
    // Normalize PWA initial route
    path: '/index.html',
    redirect: '/',
    meta: { privacy: 'public' },
  },

  {
    path: '/',
    // Redirect user based on token
    beforeEnter: (to, from, next) => {
      const userNavigation = store.state.auth?.currentUser?.navigation ?? [];
      const homeLink = userNavigation.find((item) => item.home);
      next(homeLink?.to ?? '/holdings');
    },
  },

  {
    path: '/about',
    name: 'about',
    component: AboutView,
    meta: { privacy: 'public' },
  },

  {
    path: '/error-403',
    name: 'error-403',
    component: ErrorView,
    props: { errorCode: '403' },
    meta: { privacy: 'public' },
  },

  {
    path: '/error-404',
    alias: '*',
    name: 'error-404',
    component: ErrorView,
    props: { errorCode: '404' },
    meta: { privacy: 'public' },
  },

  {
    path: '/error-500',
    name: 'error-500',
    component: ErrorView,
    props: { errorCode: '500' },
    meta: { privacy: 'public' },
  },
];
